module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-ExtraboldIt.092120a2.ttf";